// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "362" ? "__federation_expose_App" : chunkId) + "." + {"201": "d897105d","229": "f5efb9de","362": "08e30df6",}[chunkId] + ".js"
}